import React from 'react';

function Micronesia(props) {
  return (
    <svg
      {...props}
      width="36"
      height="24"
      viewBox="0 0 36 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_800_124135)">
        <mask
          id="mask0_800_124135"
             style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="36"
          height="24"
        >
          <rect width="36" height="24" fill="white" />
        </mask>
        <g mask="url(#mask0_800_124135)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0V24H36V0H0Z"
            fill="#63B3E1"
          />
          <mask
            id="mask1_800_124135"
               style={{ maskType: 'luminance' }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="36"
            height="24"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 0V24H36V0H0Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask1_800_124135)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M18 7.29999L16.0162 8.22704L16.3951 6.26351L14.7902 4.87294L17.0081 4.58646L18 2.79999L18.9919 4.58646L21.2098 4.87294L19.6049 6.26351L19.9838 8.22704L18 7.29999Z"
              fill="#F7FCFF"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M18.0001 19.3L16.0163 20.227L16.3952 18.2635L14.7903 16.8729L17.0082 16.5865L18.0001 14.8L18.992 16.5865L21.2099 16.8729L19.605 18.2635L19.9839 20.227L18.0001 19.3Z"
              fill="#F7FCFF"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M11.0251 13.5L9.04137 14.4271L9.42024 12.4635L7.81533 11.0729L10.0333 10.7865L11.0251 9L12.017 10.7865L14.235 11.0729L12.6301 12.4635L13.0089 14.4271L11.0251 13.5Z"
              fill="#F7FCFF"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M24.75 13.5L22.7662 14.4271L23.1451 12.4635L21.5402 11.0729L23.7581 10.7865L24.75 9L25.7419 10.7865L27.9598 11.0729L26.3549 12.4635L26.7338 14.4271L24.75 13.5Z"
              fill="#F7FCFF"
            />
          </g>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_800_124135">
          <rect width="36" height="24" rx="5" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Micronesia;
